export const maritalStatusData = [
    { value: 'Married', label: 'Married' },
    { value: 'Single', label: 'Single' },
    { value: 'Divored', label: 'Divored' },
    { value: 'Widowed', label: 'Widowed' },
    { value: 'Others', label: 'Others' }
];